module.exports = __webpack_public_path__ + "static/emptyc049b14d702c88b6806b4652028e0e81.png";